<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-ramo-atividade-form')
        },
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        model: {
            nome: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-ramo-atividade-form')

                this.repositories.cadastro.ramoAtividade.edit(this.id)
                    .then(({data}) => this.model.nome = data.model.nome)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-ramo-atividade-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-ramo-atividade-form')

                        const request = {...this.model}

                        if (this.id) {
                            this.repositories.cadastro.ramoAtividade.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-ramo-atividade-form'))
                        } else {
                            this.repositories.cadastro.ramoAtividade.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-ramo-atividade-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>